import { createFileRoute } from '@tanstack/react-router';

import { SchedulePage } from '@/features/admin/SchedulePage';
import { requireRouteAccess } from '@/lib/routeGuards';

export const Route = createFileRoute('/_authed/admin/schedule')({
  beforeLoad: () => requireRouteAccess('/admin/schedule'),
  component: SchedulePage,
});
